import React, { useEffect, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import {
  Container,
} from "reactstrap";
// Redux
import { connect } from "react-redux";
import {  withRouter } from "react-router-dom";
//Import Breadcrumb
import Breadcrumb_2Items from "../../../components/Common/Breadcrumb_2Items";
import "../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { postSubmitForm } from "../../../helpers/forms_helper";
import showNotification from "../../../helpers/show_notification";
import preloader from "../../../helpers/preloader";
import FPDirectTransfer from "../../../components/Transfers/Products/DirectTransfer";

const ProductsDirectTransferFromCentral = (props) => {

  const storeName = localStorage.getItem("store_name")

  useEffect(() => {
    loadAllStores();
  }, []);


  const [allBranches, setAllBranches] = useState([]);
  const loadAllStores = async () => {
    let url = process.env.REACT_APP_BASEURL + "stores/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      const result2 = response.data.filter((store) =>  (store.type === "Branch"))
      setAllBranches(result2);
    } else {
      showNotification(response.message, "Error");
    }
  };
  
  const [allItems, setAllProducts] = useState([]);
  const loadProducts = async (data) => {
    preloader(true);
    // let url = process.env.REACT_APP_BASEURL + "items/getall";
    let url = process.env.REACT_APP_BASEURL + "products/get_mapped_products";
    const response = await postSubmitForm(url, data);
    if (response && response.status === 1) {
      const updatedItems = response.data
      const selectOptions = updatedItems.map(item => ({
          _id:item.product_id,
          name:item.name,
          unit_levels:item.unit_levels,
          available:item.available,
          store_available:item.store_available,
          threshold:item.threshold,
          unit_for_threshold:item.unit_for_threshold,
          category:item.category,
          section:item.section,
        label: item.name,
        value: item.product_id
      }));
      preloader(false);
      setAllProducts(selectOptions);
    } else {
      preloader(false);
      showNotification(response.message, "Error");
    }
  };

  function loadStoreProducts(data) {
    loadProducts({ store_id: data._id })
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            title={props.t("Transfer")}
            alternateTitle={props.t("Products Transfer")}
            breadcrumbItem1={props.t("Products")}
            breadcrumbItem2={props.t("New Transfer")}
          />
           <FPDirectTransfer
            allStores={allBranches}
            allProducts={allItems}
            onStoreSelect={loadStoreProducts}
       />
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => { };
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(ProductsDirectTransferFromCentral))
);

